import React from 'react';
import styles from './IntroCopy.module.scss';
import { Body, Heading } from 'components/text';

const IntroHeader: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Heading as="h1">
          Buy a Little Emperors e&#x2011;gift card
        </Heading>
        <Body className={styles.introText} fontSize={18} weight="demiBold">
          New members get 6 months of Travel membership on us!
        </Body>
      </div>
    </div>
  );
};

export default IntroHeader;
